import { ReactNode } from 'react';
import { useServices } from '@packages/shared/core/common/hooks';

type IsFeatureOnProps = {
  children?: ReactNode;
  name: string;
};

const IsFeatureOn = ({ children, name }: IsFeatureOnProps) => {
  const { featureFlags } = useServices();

  const isFeatureOn = featureFlags.isFeatureOn(name);

  return isFeatureOn ? <>{children}</> : null;
};

export default IsFeatureOn;
